import type { ReactNode } from 'react'

export type FilterBarProps = {
  inset?: boolean
  children?: ReactNode
  trailing?: ReactNode
}

/** Layout only: callers supply their actual controls and reset actions. */
export function FilterBar({ inset = false, children, trailing }: FilterBarProps) {
  return <div className={inset ? 'filter-bar filter-bar--inset' : 'filter-bar'}>
    {children}
    {trailing !== undefined && <>
      <span className="filter-bar__sp" aria-hidden="true" />
      {trailing}
    </>}
  </div>
}
